"use client";

import { cn } from "@/lib/utils";

interface BrowserChromeProps {
  url?: string;
  children: React.ReactNode;
  className?: string;
}

export function BrowserChrome({
  url = "app.contractor-co-pilot.com",
  children,
  className,
}: BrowserChromeProps) {
  return (
    <div
      className={cn(
        "rounded-xl border border-border/60 bg-card overflow-hidden shadow-lg",
        className,
      )}
    >
      {/* Title bar */}
      <div className="flex items-center gap-2 px-4 py-2.5 bg-muted/50 border-b border-border/40">
        <div className="flex gap-1.5">
          <div className="w-2.5 h-2.5 rounded-full bg-muted-foreground/20" />
          <div className="w-2.5 h-2.5 rounded-full bg-muted-foreground/20" />
          <div className="w-2.5 h-2.5 rounded-full bg-muted-foreground/20" />
        </div>
        <div className="flex-1 mx-2">
          <div className="mx-auto max-w-xs bg-background/60 rounded-md px-3 py-1 text-[10px] text-muted-foreground font-mono text-center truncate">
            {url}
          </div>
        </div>
      </div>
      {/* Content */}
      <div className="relative">{children}</div>
    </div>
  );
}
